// src/context/AuthContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../lib/api';
import { clearToken, getToken, setToken } from '../lib/storage';

export const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadProfile = async () => {
    const token = getToken();
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const response = await api.get('/profile');
      setUser(response.data);
    } catch (error) {
      clearToken();
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProfile();
  }, []);

  const login = async (email, password) => {
    const response = await api.post('/login', { email, password });
    if (response?.data?.accessToken) {
      setToken(response.data.accessToken);
      await loadProfile();
    }
    return response.data;
  };

  const register = async (payload) => {
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      formData.append(key, value);
    });
    const response = await api.post('/register', formData);
    if (response?.data?.accessToken) {
      setToken(response.data.accessToken);
      await loadProfile();
    }
    return response.data;
  };

  const logout = () => {
    clearToken();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh: loadProfile }}>
      {children}
    </AuthContext.Provider>
  );
};
